import React, { Component } from 'react';
import infoIcon from "../../../assets/svg/link-new-tab.svg";
import Isvg from 'react-inlinesvg';


/**
* Custom checkbox
* @author   Milan Stanojevic
*/
class Checkbox extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    render() {
        let styleBox = this.props.checked ? "checkbox-v2 checkbox-v2-checked" : "checkbox-v2";
        if (this.props.styleType === 'radio') {
            styleBox = this.props.checked ? "radio-checkbox-v2 radio-checkbox-v2-checked" : "radio-checkbox-v2";
        }
        if (this.props.indeterminate) {
            styleBox = "checkbox-v2 checkbox-v2-indeterminate-checked";
        }
        const doOnChangeOnlyOnBoxClick = this.props.doOnChangeOnlyOnBoxClick ? this.props.doOnChangeOnlyOnBoxClick : false;
        return (
            <div
                className={this.props.disabled ? this.props.disabledIcon ? "checkbox-wrap-v2 checkbox-wrap-v2-disabled checkbox-wrap-v2-disabled-icon" : "checkbox-wrap-v2 checkbox-wrap-v2-disabled" : "checkbox-wrap-v2"}
            // onClick={(e) => {

            //     if (!this.props.onChange || doOnChangeOnlyOnBoxClick) {
            //         return;
            //     }
            //     let obj = {
            //         target: {
            //             checked: !this.props.checked
            //         }
            //     }

            //     this.props.onChange(obj);
            // }}
            >
                <div
                    className={styleBox}
                    style={{ border: this.props.error ? '1px solid #dc3545' : 'none' }}
                    onClick={() => {
                        if (doOnChangeOnlyOnBoxClick && this.props.onChange) {
                            let obj = {
                                target: {
                                    checked: !this.props.checked
                                }
                            }

                            this.props.onChange(obj);
                        }
                        if (!this.props.onChange) {
                            return;
                        }
                        let obj = {
                            target: {
                                checked: !this.props.checked
                            }
                        }

                        this.props.onChange(obj);
                    }}
                >
                </div>
                <span
                    style={this.props.small ? { color: this.props.error && !this.props.errorLabelDisabled ? '#dc3545' : 'black', fontSize: 14 } : this.props.fullWidth ? { color: this.props.error && !this.props.errorLabelDisabled ? '#dc3545' : 'black', width: '100%' } : { color: this.props.error && !this.props.errorLabelDisabled ? '#dc3545' : 'black' }}
                    className={this.props.labelInfo || this.props.tooltip || this.props.tooltipV2 ? this.props.lighterText ? "flex-center checkbox-lighter-text" : 'flex-center' : this.props.lighterText ? "checkbox-lighter-text" : ""}
                    onClick={() => {
                        if (this.props.labelAction) {
                            this.props.labelAction();
                        }

                        if (!this.props.onChange || doOnChangeOnlyOnBoxClick) {
                            return;
                        }
                        let obj = {
                            target: {
                                checked: !this.props.checked
                            }
                        }

                        this.props.onChange(obj);
                    }}
                >

                    {
                        this.props.tooltipV2 ?
                            <div className={this.props.lighterText ? "checkbox-lighter-text" : ""}>{this.props.label}</div>
                            :
                            this.props.label
                    }
                    {this.props.additionalInfo ? <span style={{ color: '#758195', fontWeight: 300 }}> ({this.props.additionalInfo})</span> : null}
                    {
                        this.props.labelInfo ?
                            <div className='label-info'>
                                <Isvg src={infoIcon} />
                                <div className="info-text">{this.props.labelInfo}</div>
                            </div>
                            :
                            null
                    }
                    {
                        this.props.tooltip ?
                            <div className='tooltip-label-info'>
                                <Isvg src={infoIcon} />
                                <div className="info-text">{this.props.tooltip}</div>
                            </div>
                            :
                            null
                    }
                    {
                        this.props.tooltipV2 ?
                            <div className='tooltip-label-info'>
                                <Isvg src={infoIcon} />
                                <div className="info-text">{this.props.tooltipV2}</div>
                            </div>
                            :
                            null
                    }
                    {
                        this.props.suffixText ?
                            <span style={{ marginLeft: 5, fontSize: 12, color: '#758195', fontWeight: 300 }} className={this.props.suffixTextClassName}>{this.props.suffixText}</span>
                            :
                            null
                    }

                </span>
            </div>
        );
    }
}

export default Checkbox;